<template>
    <div class="home">
        <div class="container">

            <div v-if="kizilayGirisFormunuAc" class="w-75 mx-auto my-5 text-center">
                <b-alert show variant="danger">Gmail adresiniz sistemde bulunamadı.</b-alert>
                <b-alert show variant="info">
                    Kızılay Kullanıcı Adınızı ve Şifreniz yazdıktan sonra <b>Gmail</b> ile giriş yapabilirsiniz.
                </b-alert>
            </div>


            <b-form v-if="kizilayGirisFormunuAc" class="w-75 mx-auto my-5" method="post">
                <b-form-group label="Kızılay Kullanıcı Adınız" label-for="kkad">
                    <b-form-input v-model="kizilay.kullanici" name="kkad" id="kkad"/>
                </b-form-group>
                <b-form-group label="Kızılay Şifreniz" label-for="kksifre">
                    <b-form-input type="password" v-model="kizilay.sifre" name="kksifre" id="kksifre"/>
                </b-form-group>

            </b-form>
            <google-signin-btn class="my-5 d-block w-75 mx-auto text-center"
                               label="Google ile Giriş Yap" @click="googleileGirisYap"/>
        </div>


    </div>
</template>

<script>
    import {GoogleIleGirisYap} from "@/utils/googlegiris";

    export default {
        name: "girisyap",
        data() {
            return {
                kizilay: {
                    kullanici: '',
                    sifre: ''
                },
                kizilayGirisFormunuAc: false,
            }
        },
        methods: {
            googleileGirisYap: async function () {
                const netice = await new GoogleIleGirisYap(this, this.kizilay.kullanici, this.kizilay.sifre);
                if (netice.hataVarMi) {
                    if (netice.kod === "gmail.kayitli.degil") {
                        this.kizilayGirisFormunuAc = true;
                    }
                } else {
                    const urlParams = new URLSearchParams(window.location.search);
                    await this.$router.push(urlParams.get('url') || "/");
                }

            },

        },
        mounted() {

        },
        created() {

        }
    }
</script>
